var image_viewer_rtlignore_default = {
  "fontElementMap": "IXO4P",
  "imageContainer": "zP1sj",
  "expandButton": "_2Sna-",
  "expandIcon": "MhtI8",
  "pointer": "cXI-Q",
  "imageWrapper": "dAYZC",
  "imageRatio": "DvZU8",
  "image": "_3q5cv",
  "imageOverlay": "oqkix",
  "imagePreload": "U1hBP",
  "imageHighres": "pvAHk",
  "onlyHighRes": "Kh3ll",
  "image_loading": "aYCpH"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
